const USER_NAME_KEY = 'jsyog.userName';
const REGISTRATION_ID_KEY = 'jsyog.registrationId';
const PRACTICAL_CENTER_KEY = 'jsyog.practicalCenter';
const MNAME_KEY = 'jsyog.mname';
const EXAM_START_TIME_KEY = 'jsyog.examStartTime';
const EXAM_END_TIME_KEY = 'jsyog.examEndTime';
const ROLLNO_KEY = 'jsyog.rollno';

export function setUserSession(
  name?: string,
  registrationId?: number,
  practicalCenter?: string,
  mname?: string,
  startTime?: string,
  endTime?: string,
  rollno?: string
): void {
  try {
    if (name) localStorage.setItem(USER_NAME_KEY, name);
    if (registrationId != null) localStorage.setItem(REGISTRATION_ID_KEY, String(registrationId));
    if (practicalCenter != null) localStorage.setItem(PRACTICAL_CENTER_KEY, practicalCenter);
    if (mname != null) localStorage.setItem(MNAME_KEY, mname);
    if (startTime) localStorage.setItem(EXAM_START_TIME_KEY, startTime);
    if (endTime) localStorage.setItem(EXAM_END_TIME_KEY, endTime);
    if (rollno) localStorage.setItem(ROLLNO_KEY, rollno);
  } catch {
    // ignore storage errors
  }
}

export function setPracticalCenter(center: string): void {
  try {
    localStorage.setItem(PRACTICAL_CENTER_KEY, center);
  } catch {
    // ignore
  }
}

export function getPracticalCenter(): string {
  try {
    return localStorage.getItem(PRACTICAL_CENTER_KEY) ?? '';
  } catch {
    return '';
  }
}

export function getMName(): string {
  try {
    return localStorage.getItem(MNAME_KEY) ?? '';
  } catch {
    return '';
  }
}

export function getUserName(): string {
  try {
    return localStorage.getItem(USER_NAME_KEY) ?? '';
  } catch {
    return '';
  }
}

export function getExamStartTime(): string {
  try {
    return localStorage.getItem(EXAM_START_TIME_KEY) ?? '';
  } catch {
    return '';
  }
}

export function getExamEndTime(): string {
  try {
    return localStorage.getItem(EXAM_END_TIME_KEY) ?? '';
  } catch {
    return '';
  }
}

export function getRollNo(): string {
  try {
    return localStorage.getItem(ROLLNO_KEY) ?? '';
  } catch {
    return '';
  }
}

export function clearUserSession(): void {
  try {
    localStorage.removeItem(USER_NAME_KEY);
    localStorage.removeItem(REGISTRATION_ID_KEY);
    localStorage.removeItem(PRACTICAL_CENTER_KEY);
    localStorage.removeItem(MNAME_KEY);
    localStorage.removeItem(EXAM_START_TIME_KEY);
    localStorage.removeItem(EXAM_END_TIME_KEY);
  } catch {
    // ignore
  }
}
